module.exports = __webpack_public_path__ + "static/media/leftarrCircle.3f633a7e.svg";